export default __webpack_public_path__ + "static/media/DSC_7650-edited.267ebf34.jpg";